import {Types} from "./action";
import _ from "lodash";
// import {NotificationManager} from 'react-notifications';

// import cleanDeep from 'clean-deep';


const defaultState = {
  ad: {}
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case Types.PAYMENT_MACHINE_NEW_MODAL: {

      let newState = {...state};

      newState.paymentMachine.newModal = action.show;
      newState.paymentMachine.item = {};

      return newState;
    }
    case Types.PAYMENT_MACHINE_GET_ITEM: {

      let newState = {...state};

      newState.paymentMachine.item = action.payload.data.getPaymentMachine;

      if (newState.paymentMachine.item){
          newState.paymentMachine.item.settings = JSON.parse(newState.paymentMachine.item.settings)
      }

      return newState;
    }
    case Types.PAYMENT_MACHINE_CLEAR_ITEM: {

      let newState = {...state};

      newState.paymentMachine.item = {};

      return newState;
    }
    case Types.PAYMENT_MACHINE_GET_SEARCH: {

      let newState = {...state};

      const newItems = action.payload.data.listPaymentMachines.items.filter(item => item._deleted != true)

      // TODO add sorting facility
      newState.paymentMachine.search = _.sortBy(newItems,['givenName','familyName'])

      return newState;
    }
    case Types.PAYMENT_MACHINE_GET_LIST: {

      let newState = {...state};

      const existingList = newState.paymentMachine.list || []

      const newItems = action.payload.data.listPaymentMachines.items.filter(item => item._deleted != true)

      const merged = _(existingList) // start sequence
        .keyBy('id') // create a dictionary of the 1st array
        .merge(_.keyBy(newItems, 'id')) // create a dictionary of the 2nd array, and merge it to the 1st
        .values() // turn the combined dictionary to array
        .value(); // get the value (array) out of the sequence


      // TODO add sorting facility
      newState.paymentMachine.list = merged // _.sortBy(merged,['givenName','familyName'])


      newState.paymentMachine.listNextToken = action.payload.data.listPaymentMachines.nextToken;
      newState.paymentMachine.listStartedAt = action.payload.data.listPaymentMachines.startedAt;
      console.log('updatedPaymentMachineList',newState.paymentMachine.list)

      return newState;
    }
    case Types.PAYMENT_MACHINE_UPDATE_ITEM: {

      let newState = {...state};

      const updatedItem = action.payload.data.updatePaymentMachine || action.payload.data.onUpdatePaymentMachine;
      newState.paymentMachine.item = updatedItem;

      if (newState.paymentMachine.list){
        const itemIndex = newState.paymentMachine.list.findIndex(item => item.id == updatedItem.id)
        newState.paymentMachine.list[itemIndex] = updatedItem;
        newState.paymentMachine.list = newState.paymentMachine.list // _.sortBy(newState.paymentMachine.list,['givenName','familyName'])
      }

      if (action.callback && typeof(action.callback == 'function')){
        action.callback(updatedItem)
      }

      console.log('newPaymentMachineUpdated',newState.paymentMachine.item)

      return newState;
    }
    case Types.PAYMENT_MACHINE_DELETE_ITEM: {

      let newState = {...state};

      const deletedItem = action.payload;
      // newState.service.item = deletedItem;

      if (newState.paymentMachine.list){
        newState.paymentMachine.list = _.reject(newState.paymentMachine.list,{id: deletedItem})
      }

      console.log('adDeleted')

      return newState;
    }
    case Types.PAYMENT_MACHINE_CREATE_ITEM: {

      let newState = {...state};

      const createdItem = action.payload.data.createPaymentMachine || action.payload.data.onCreatePaymentMachine;
      
      const exists = newState.ad && newState.paymentMachine.list && newState.paymentMachine.list.find(item => item.id == createdItem.id)

      if (exists){
        return state;
      }

      if (newState.paymentMachine.list){
        newState.paymentMachine.list.push(createdItem);
        newState.paymentMachine.list = _.sortBy(newState.paymentMachine.list,['givenName','familyName'])
      }

      if (newState.paymentMachine.newModal){
        newState.paymentMachine.newModal = false;
      } else {
        // do not set ad item if inside a modal
        newState.paymentMachine.item = createdItem;
      }


      if (action.callback && typeof(action.callback == 'function')){
        action.callback(createdItem)
      }

      return newState;
    }
    case Types.PAYMENT_MACHINE_UPDATE_IMAGE: {

      let newState = {...state};

      newState.paymentMachine.item = {...newState.paymentMachine.item};
      newState.paymentMachine.item.image = action.image;

      if (newState.paymentMachine.list){
        const itemIndex = newState.paymentMachine.list.findIndex(item => item.id == newState.paymentMachine.item.id)
        newState.paymentMachine.list[itemIndex] = newState.paymentMachine.item;
        newState.paymentMachine.list = _.sortBy(newState.paymentMachine.list,'name')
      }

      return newState;
    }
    default:
      return state;
  }
};

export default reducer;